function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8 22h52.3C56.2 10.4 45.1 2 32 2C22.2 2 13.5 6.7 8 14v8z",
  fill: "#3e4347"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M60.3 22H8v20h52.3c1.1-3.1 1.7-6.5 1.7-10s-.6-6.9-1.7-10",
  fill: "#f9f9f9"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M8 42v8c5.5 7.3 14.2 12 24 12c13.1 0 24.2-8.3 28.3-20H8z",
  fill: "#75a843"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M8 14c-3.8 5-6 11.2-6 18s2.2 13 6 18l24-18L8 14",
  fill: "#c94747"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffffff",
  d: "M11 29.7l1-2.7l1 2.7l2.5-1.2l-1.2 2.5l2.7 1l-2.7 1l1.2 2.5l-2.5-1.2l-1 2.7l-1-2.7l-2.5 1.2L9.7 33L7 32l2.7-1l-1.2-2.5z"
});

var SvgJordan = function SvgJordan(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--emojione",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgJordan, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/jordan.4e8d5ada.svg";
export { ForwardRef as ReactComponent };